var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExploreProducstWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8898_104483)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1429 2.57143C6.40899 2.57143 2.57143 6.40899 2.57143 11.1429C2.57143 15.8767 6.40899 19.7143 11.1429 19.7143C15.8767 19.7143 19.7143 15.8767 19.7143 11.1429C19.7143 6.40899 15.8767 2.57143 11.1429 2.57143ZM0 11.1429C0 4.98883 4.98883 0 11.1429 0C17.297 0 22.2857 4.98883 22.2857 11.1429C22.2857 13.6013 21.4896 15.8738 20.141 17.7166L23.4982 21.0739C24.1678 21.7433 24.1678 22.8288 23.4982 23.4982C22.8288 24.1677 21.7435 24.1677 21.0739 23.4982L17.7166 20.141C15.8738 21.4896 13.6013 22.2857 11.1429 22.2857C4.98883 22.2857 0 17.297 0 11.1429ZM9.72422 5.85749C10.0508 4.34069 12.1975 4.32987 12.5374 5.84522L12.5825 6.04623C13.0107 7.95552 14.5208 9.40503 16.3992 9.73733C17.9621 10.0138 17.9621 12.2719 16.3992 12.5484C14.5208 12.8807 13.0107 14.3302 12.5825 16.2395L12.5374 16.4405C12.1975 17.9558 10.0507 17.945 9.72422 16.4282L9.68709 16.2557C9.27446 14.339 7.76597 12.8784 5.88417 12.5455C4.32434 12.2696 4.32432 10.0161 5.88417 9.74018C7.76597 9.40728 9.27446 7.94674 9.68709 6.02998L9.72422 5.85749Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8898_104483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreProducstWhite);
export default __webpack_public_path__ + "static/media/explore_producst_white.d76310f23a8c272233f0cf790ead41e7.svg";
export { ForwardRef as ReactComponent };